import { HourGlassIcon, LockIcon } from '@cof/plastic-components';
import { useTheme } from 'styled-components';

const useIcon = (page: any, submitting: any, defaultIcon = LockIcon) => {
    const theme = useTheme();
    // @ts-expect-error TS2339: Property 'pages' does not exist on type 'DefaultTheme'.
    const themeIcon = theme?.pages?.[page]?.icon;

    if (submitting === true) {
        return themeIcon ?? HourGlassIcon;
    }
    return themeIcon ?? defaultIcon;
};

export default useIcon;
